import { Button, Dropdown, Form, FormInstance, Input, MenuProps } from "antd";
import { MoreOutlined } from "@ant-design/icons";
import { MouseEvent, useCallback, useMemo, useState } from "react";
import { CustomerInputSearch } from "../../../../../../../../../components/CustomerInputSearch";

type TPayeeInputProps = {
  form: FormInstance;
  payeesNumber: {
    primaryBuyerNumber: number;
    primarySellerNumber: number;
  };
  label: string;
  name: string;
  idItemName: string;
  isFormDisabled: boolean;
  isFieldRequired?: boolean;
};

export const PayeeInput = ({
  form,
  payeesNumber,
  label,
  name,
  idItemName,
  isFormDisabled,
  isFieldRequired,
}: TPayeeInputProps) => {
  const [key, setKey] = useState(false);

  const onChange = useCallback(
    (event: MouseEvent<HTMLDivElement>) => {
      const id: string = event.currentTarget.id;

      const value: number =
        id === "1"
          ? payeesNumber.primaryBuyerNumber
          : payeesNumber.primarySellerNumber;

      form.setFieldValue(name, value);
      setKey(!key);
    },
    [form, name, payeesNumber, key],
  );

  const onSuccess = useCallback(
    (value: any) => {
      form.setFieldValue("payeeName", value?.name);
    },
    [form],
  );

  const items: MenuProps["items"] = useMemo(() => {
    const value = [
      {
        key: "1",
        label: (
          <div id="1" onClick={onChange}>
            Set Primary Buyer
          </div>
        ),
      },
      {
        key: "2",
        label: (
          <div id="2" onClick={onChange}>
            Set Primary Seller
          </div>
        ),
      },
    ];

    return value;
  }, [onChange]);

  return (
    <div className="d-flex">
      <CustomerInputSearch
        form={form}
        label={label}
        name={name}
        isFormDisabled={isFormDisabled}
        idItemName={idItemName}
        placeholder="Input Payee#, “Enter” to confirm"
        additionalClass="flex-grow-1"
        isFieldRequired={isFieldRequired}
        key={`${key}-${name}`}
        onSuccess={onSuccess}
      />
      <Dropdown
        className="ml-2 mt-6"
        menu={{ items }}
        disabled={isFormDisabled}
        trigger={["click"]}
      >
        <Button shape="circle" icon={<MoreOutlined />}></Button>
      </Dropdown>
      <Form.Item hidden name="payeeName">
        <Input />
      </Form.Item>
    </div>
  );
};
